import { GET_PLAYER_PRICES } from "network/queries/player-prices"
import NetworkClient from "network/apollo"
import styled from "styled-components"
import _ from "lodash"
import React, { useEffect } from "react"
import { isBrowser } from "react-device-detect"
import { events } from "analytics/events"
import { pushToFirebase } from "analytics/manager"
import { Hidden } from "@material-ui/core"
import DownloadDialog from "components/elements/Download-dialog"
import axios from "axios"

const StyledDiv = styled.div`
  cursor: pointer;
  @-webkit-keyframes ticker {
    0% {
      -webkit-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
      visibility: visible;
    }
    100% {
      -webkit-transform: translate3d(-100%, 0, 0);
      transform: translate3d(-100%, 0, 0);
    }
  }

  @-moz-keyframes ticker {
    0% {
      -webkit-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
      visibility: visible;
    }
    100% {
      -webkit-transform: translate3d(-100%, 0, 0);
      transform: translate3d(-100%, 0, 0);
    }
  }

  @-ms-keyframes ticker {
    0% {
      -webkit-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
      visibility: visible;
    }
    100% {
      -webkit-transform: translate3d(-100%, 0, 0);
      transform: translate3d(-100%, 0, 0);
    }
  }

  @-o-keyframes ticker {
    0% {
      -webkit-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
      visibility: visible;
    }
    100% {
      -webkit-transform: translate3d(-100%, 0, 0);
      transform: translate3d(-100%, 0, 0);
    }
  }

  @keyframes ticker {
    0% {
      -webkit-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
      visibility: visible;
    }
    100% {
      -webkit-transform: translate3d(-100%, 0, 0);
      transform: translate3d(-100%, 0, 0);
    }
  }

  .ticker-wrap {
    animation: 3.1s slideInFromBottom;
    -webkit-animation: 3.1s slideInFromBottom;
    position: fixed;
    bottom: 0;
    width: 100%;
    overflow: hidden;
    height: 60px;
    background-color: rgba(255, 255, 255, 255);
    padding-left: 100vw;
    box-sizing: content-box;
    z-index: 9999;
    border-top: 1px dotted #2c3239;
  }

  .ticker-wrap .ticker {
    display: inline-block;
    height: 60px;
    line-height: 60px;
    white-space: nowrap;
    padding-right: 100%;
    box-sizing: content-box;
    -webkit-animation-iteration-count: infinite;
    animation-iteration-count: infinite;
    -webkit-animation-timing-function: linear;
    animation-timing-function: linear;
    -webkit-animation-name: ticker;
    -moz-animation-name: ticker;
    -ms-animation-name: ticker;
    -o-animation-name: ticker;
    animation-name: ticker;
    -webkit-animation-duration: 2000s;
    -moz-animation-name: ticker;
    -ms-animation-duration: 2000s;
    -o-animation-duration: 2000s;
    animation-duration: 2000s;
  }

  .ticker-wrap .ticker:hover {
    animation-play-state: paused;
  }

  .ticker-wrap .ticker__item {
    display: inline-block;
    padding: 0 1rem;
    font-size: 18px;
    color: #2c3239;
    font-family: "rajdhani", sans-serif;
    font-weight: 600;
  }

  .playerPrice {
    font-size: 18px;
    color: #6642bc;
  }

  .playerPriceDifferenceNegative {
    background-color: #ffe5e3;
    color: #e63425;
    font-size: 12px;
    padding: 0px 3px;
  }

  .playerPriceDifferencePositive {
    background-color: #caf0da;
    color: #0e9828;
    font-size: 12px;
    padding: 0px 3px;
  }
`
export default () => {
  const [openDialogName, setOpenDialog] = React.useState(false)

  const openDownloadDialog = () => {
    setOpenDialog(true)
    pushToFirebase(events.web.web_home_CTA_tickerBar)
  }

  const closeDialog = () => {
    setOpenDialog(false)
  }

  const fetchTickertapeData = async () => {
    try {
      let tickerText = ""
      const tickerTapeResponse = await axios.get(
        "https://gateway.sixergame.com/sixer_client_service/api/sixer-client-service/v1/ticker-players"
      )
      if (
        tickerTapeResponse.status == 200 &&
        tickerTapeResponse.data != null &&
        tickerTapeResponse.data.data != null &&
        tickerTapeResponse.data.data.message != null &&
        Array.isArray(tickerTapeResponse.data.data.message) &&
        tickerTapeResponse.data.data.message.length > 0
      ) {
        tickerTapeResponse.data.data.message.forEach(item => {
          if (!item.change_pct) {
            return
          }
          if (item.change_pct > 0) {
            tickerText +=
              '<div class="ticker__item"> <span class="playerName">' +
              item.player_name +
              '</span> <span class="playerPrice"> ' +
              Number(item.current_price).toFixed(2) +
              '</span> <span class="playerPriceDifferencePositive"> ' +
              item.change_pct +
              "%" +
              "</span></div>"
          } else {
            tickerText +=
              '<div class="ticker__item"> <span class="playerName">' +
              item.player_name +
              '</span> <span class="playerPrice"> ' +
              Number(item.current_price).toFixed(2) +
              '</span> <span class="playerPriceDifferenceNegative"> ' +
              item.change_pct +
              "%" +
              "</span></div>"
          }
        })
        document.querySelector(".ticker")!.innerHTML = tickerText
      }
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    fetchTickertapeData()
  }, [])

  // NetworkClient.query({
  //   query: GET_PLAYER_PRICES,
  // })
  //   .then(async function (result: { data: any }) {
  //     // Get players data
  //     const playerData = result.data
  //     const playerAssets = playerData.sixergame_metc_player_assets
  //     const playerMarketData = playerData.sixer_marketdata
  //     const playerPriceChange = playerData.price_change_three_game

  //     let tikerText: string = "",
  //       playerPrice: string,
  //       startPrice,
  //       endPrice,
  //       priceChange: string,
  //       isPositive: boolean = false
  //     playerAssets.forEach(function (sixersAsset: {
  //       symbol: any
  //       sixerConnect: { name: string }
  //     }) {
  //       if (sixersAsset) {
  //         let playerSymbol = sixersAsset.symbol
  //         var objPlayerMarketData = _.filter(playerMarketData, {
  //           symbol: playerSymbol,
  //         })

  //         if (typeof objPlayerMarketData[0] != "undefined") {
  //           playerPrice = objPlayerMarketData[0].sixer_marketdata_element.price
  //         }
  //         var objPlayerPriceChange = _.filter(playerPriceChange, {
  //           symbol: playerSymbol,
  //         })

  //         if (typeof objPlayerPriceChange[0] != "undefined") {
  //           if (objPlayerPriceChange[0].start_price) {
  //             startPrice = objPlayerPriceChange[0].start_price
  //           } else {
  //             startPrice = 0
  //           }
  //           endPrice = playerPrice ? playerPrice : 0

  //           var v = Number(
  //             ((Number(endPrice) - Number(startPrice)) / Number(startPrice)) *
  //               100
  //           )
  //           if (!v) {
  //             v = 0
  //           }
  //           if (v.toString() === "Infinity") {
  //             v = 0
  //           }
  //           if (v === 0) {
  //             priceChange = "0.00 %"
  //             isPositive = true
  //           } else if (v > 0) {
  //             priceChange = "+" + v.toFixed(2) + "%"
  //             isPositive = true
  //           } else {
  //             priceChange = v.toFixed(2) + "%"
  //             isPositive = false
  //           }
  //         }

  //         let playerName = sixersAsset.sixerConnect
  //         if (playerName) {
  //           if (isPositive) {
  //             tikerText +=
  //               '<div class="ticker__item"> <span class="playerName">' +
  //               sixersAsset.sixerConnect.name +
  //               '</span> <span class="playerPrice"> ' +
  //               Number(playerPrice).toFixed(2) +
  //               '</span> <span class="playerPriceDifferencePositive"> ' +
  //               priceChange +
  //               "</span></div>"
  //           } else {
  //             tikerText +=
  //               '<div class="ticker__item"> <span class="playerName">' +
  //               sixersAsset.sixerConnect.name +
  //               '</span> <span class="playerPrice"> ' +
  //               Number(playerPrice).toFixed(2) +
  //               '</span> <span class="playerPriceDifferenceNegative"> ' +
  //               priceChange +
  //               "</span></div>"
  //           }
  //         }
  //       }
  //     })
  //     document.querySelector(".ticker")!.innerHTML = tikerText
  //   })
  //   .catch(async function (error: any) {
  //     console.log("Error in login request. Error - ")
  //     console.log(error)
  //   })
  if (isBrowser) {
    return (
      <StyledDiv>
        <div className="ticker-wrap">
          <div
            className="ticker"
            onClick={() => {
              openDownloadDialog()
            }}
          ></div>
          <Hidden smDown implementation="css">
            <DownloadDialog
              open={openDialogName == true}
              handleClose={closeDialog}
            />
          </Hidden>
        </div>
      </StyledDiv>
    )
  }

  return <div></div>
}
